import { FormFieldType } from 'types';
import { RadioField } from 'components';
import { fieldArrayDisallowedNestedFieldTypes } from 'utils/form';

import { Fields } from './fields';
import { FormFieldArrayFieldProps } from './types';
import { fieldArrayLayoutOptions } from './config';

export const FormFieldArrayField = ({
  name,
  value,
  simplified = false,
  allowInputId = false,
  allowReferenceCodes = false,
}: FormFieldArrayFieldProps) => {
  if (simplified) {
    return (
      <Fields
        simplified
        enableSorting
        allowInputId={allowInputId}
        name={`${name}.options.fields`}
        fields={value.options?.fields ?? []}
        allowReferenceCodes={allowReferenceCodes}
        allowOutcomes={
          !fieldArrayDisallowedNestedFieldTypes.has(FormFieldType.OUTCOMES)
        }
        allowFieldArray={
          !fieldArrayDisallowedNestedFieldTypes.has(FormFieldType.FIELD_ARRAY)
        }
        allowOutcomeFields={
          !fieldArrayDisallowedNestedFieldTypes.has(
            FormFieldType.OUTCOME_FIELDS
          )
        }
      />
    );
  }

  return (
    <div className="flex flex-col gap-4">
      <RadioField
        row
        label="Input type"
        name={`${name}.options.layout`}
        options={fieldArrayLayoutOptions}
      />

      <Fields
        simplified={simplified}
        enableSorting={simplified}
        allowInputId={allowInputId}
        name={`${name}.options.fields`}
        fields={value.options?.fields ?? []}
        allowReferenceCodes={allowReferenceCodes}
        allowOutcomes={
          !fieldArrayDisallowedNestedFieldTypes.has(FormFieldType.OUTCOMES)
        }
        allowFieldArray={
          !fieldArrayDisallowedNestedFieldTypes.has(FormFieldType.FIELD_ARRAY)
        }
        allowOutcomeFields={
          !fieldArrayDisallowedNestedFieldTypes.has(
            FormFieldType.OUTCOME_FIELDS
          )
        }
      />
    </div>
  );
};
